
import React from "react";
import { projects } from "../data/data";

export default function Projects() {
    return (
        <section id="projects" className="text-gray-400 bg-gray-900 body-font">
            <div className="container px-5 py-10 mx-auto text-center lg:px-30">
                <div className="flex flex-col w-full mb-20">
                    <i className="fa-sharp fa-solid fa-code fa-spin m-4" style={{ color: "#63E6BE", fontSize: "50px" }}></i>
                    <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
                        Apps I've Built
                    </h1>
                    <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                        These are a collection of the best Applications I have built to learn various technologies.
                    </p>
                    <h3 className="text-xl font-medium title-font mt-4 text-white block lg:hidden">
                        Tap on each card to see info
                    </h3>
                </div>
                <div className="flex flex-wrap -m-4 justify-center">
                    {projects.map((project) => (
                        <div
                            key={project.github}
                            className="sm:w-1/2 rounded-full p-4 m-2lg:h-64">
                            <div className="flex relative h-full w-full">
                                <img
                                    alt="gallery"
                                    className="absolute inset-0 w-full h-full object-cover object-center"
                                    src={project.image}
                                />
                                <div className="transition-all duration-500 px-8 py-10 relative z-10 w-full  opacity-0 hover:backdrop-blur-2xl hover:opacity-100 hover:backdrop-brightness-50">
                                    <a href={project.github} target="_blank" rel="noreferrer" className="absolute top-0 right-9 m-4">
                                        <i class="scale-125 m-2 hover:scale-150 fa-brands fa-github"></i>
                                    </a >
                                    {project.deployed && (
                                        <a href={project.deployed} target="_blank" rel="noreferrer" className="absolute top-0 right-0 m-4">
                                            <i class="scale-125 m-2 hover:scale-150 fa-solid fa-arrow-up-right-from-square"></i>
                                        </a>
                                    )}

                                    <h2 className="tracking-widest text-sm title-font font-medium text-green-400 my-1">
                                        {project.stack}
                                    </h2>
                                    <h1 className="title-font text-lg font-medium text-white mb-3">
                                        {project.title}
                                    </h1>
                                    <p className="leading-relaxed">{project.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}